import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "menu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "wrapper" }
const _hoisted_7 = { class: "menus" }
const _hoisted_8 = {
  key: 0,
  class: "num"
}
const _hoisted_9 = {
  key: 0,
  class: "num"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://yumepr.com/lp/?y=001",
    target: "_blank"
  }, "夢叶えるプロジェクトとは")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.cred-in.com/company/",
    target: "_blank"
  }, "運営会社")
], -1)

import { computed, onBeforeUpdate, ref, watch } from 'vue'
import { RouterLink, useRouter } from 'vue-router'

import { REGISTER_TYPES } from '@/common/const'
import { useStore } from '@/store/useStore'
import { User } from '@/types/user'


export default /*#__PURE__*/_defineComponent({
  __name: 'MenuComponent',
  setup(__props) {

const router = useRouter()
const store = useStore()
const isSignedIn = computed(() => store.state.signedIn)
const userInfo = ref<User>()
const showMenu = ref<boolean>(false)
const notReadReceivedOrdersCount = ref<number>(0)
const receivedOrdersCount = ref<number>(0)
const orderedOrdersCount = ref<number>(0)

const isReceiver = computed(() => userInfo.value && userInfo.value.registerType !== REGISTER_TYPES.ORDER)
const isLiveStreamer = computed(() => userInfo.value && userInfo.value.liveFlag)

// 遷移を検知したらメニューを閉じる
watch(
  () => router.currentRoute.value.path,
  () => {
    closeShowMenu()
  }
)

const toggleShowMenu = () => {
  showMenu.value = !showMenu.value
}

const closeShowMenu = () => {
  showMenu.value = false
}

// NOTE:onMounted()ではisSignedInの更新が反映されないため onBeforeUpdate()を使用
onBeforeUpdate(async () => {
  if (isSignedIn.value) {
    // Storeからユーザ情報取得
    userInfo.value = store.getters.ownUserInfo
    try {
      // 受注未読件数
      notReadReceivedOrdersCount.value = await store.dispatch('getNotReadReceivedOrdersCount')
      // 予約件数
      orderedOrdersCount.value = await store.dispatch('getOrderedOrdersCount')
      // 受注件数
      receivedOrdersCount.value = await store.dispatch('getReceivedOrdersCount')
    } catch (error) {
      console.error(error)
    }
  }
})

const handler = {
  onLogoutButtonClick: () => {
    toggleShowMenu()
    store.dispatch('logout')
  },
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "sp-btn",
      class: _normalizeClass(["button -sp", { active: showMenu.value }]),
      onClick: toggleShowMenu
    }, _hoisted_5, 2),
    _createElementVNode("nav", {
      id: "gnav",
      class: _normalizeClass(["nav", { active: showMenu.value }])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["inner", { active: showMenu.value }])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", {
              class: _normalizeClass(["menu", { active: showMenu.value }])
            }, [
              _createElementVNode("li", { onClick: closeShowMenu }, [
                _createVNode(_unref(RouterLink), { to: { name: 'home' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("ホーム")
                  ]),
                  _: 1
                })
              ]),
              (isSignedIn.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("li", { onClick: closeShowMenu }, [
                      _createVNode(_unref(RouterLink), { to: { name: 'userDetail' } }, {
                        default: _withCtx(() => [
                          _createTextVNode("プロフィール")
                        ]),
                        _: 1
                      })
                    ]),
                    _createElementVNode("li", { onClick: closeShowMenu }, [
                      _createVNode(_unref(RouterLink), { to: { name: 'orderedOrders' } }, {
                        default: _withCtx(() => [
                          _createTextVNode("予約管理"),
                          (orderedOrdersCount.value > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(orderedOrdersCount.value), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    (isReceiver.value)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          onClick: closeShowMenu
                        }, [
                          _createVNode(_unref(RouterLink), { to: { name: 'receivedOrders' } }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 受注一覧"),
                              (receivedOrdersCount.value > 0)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(receivedOrdersCount.value), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (isLiveStreamer.value)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 1,
                          onClick: closeShowMenu
                        }, [
                          _createVNode(_unref(RouterLink), { to: { name: 'hostedLiveStreams' } }, {
                            default: _withCtx(() => [
                              _createTextVNode("配信履歴")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (isReceiver.value || isLiveStreamer.value)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 2,
                          onClick: closeShowMenu
                        }, [
                          _createVNode(_unref(RouterLink), { to: { name: 'revenueReport' } }, {
                            default: _withCtx(() => [
                              _createTextVNode("売上管理")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    (isReceiver.value)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 3,
                          onClick: closeShowMenu
                        }, [
                          _createVNode(_unref(RouterLink), { to: { name: 'withdrawal' } }, {
                            default: _withCtx(() => [
                              _createTextVNode("振込申請")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("li", null, [
                      _createVNode(_unref(RouterLink), {
                        to: { name: 'home' },
                        onClick: handler.onLogoutButtonClick
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("ログアウト")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    onClick: closeShowMenu
                  }, [
                    _createVNode(_unref(RouterLink), { to: { name: 'lineLogin' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("ログイン / 新規登録（無料）")
                      ]),
                      _: 1
                    })
                  ]))
            ], 2),
            _createElementVNode("ul", {
              class: _normalizeClass(["menu", { active: showMenu.value }])
            }, [
              _hoisted_10,
              _createElementVNode("li", { onClick: closeShowMenu }, [
                _createVNode(_unref(RouterLink), { to: { name: 'inquiry' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("お問い合わせ")
                  ]),
                  _: 1
                })
              ])
            ], 2),
            _createElementVNode("ul", {
              class: _normalizeClass(["menu", { active: showMenu.value }])
            }, [
              _createElementVNode("li", { onClick: closeShowMenu }, [
                _createVNode(_unref(RouterLink), { to: { name: 'termOfService' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("利用規約")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", { onClick: closeShowMenu }, [
                _createVNode(_unref(RouterLink), { to: { name: 'specifiedCommercialTransactionAct' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("特定商取引法")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", { onClick: closeShowMenu }, [
                _createVNode(_unref(RouterLink), { to: { name: 'privacyPolicy' } }, {
                  default: _withCtx(() => [
                    _createTextVNode("プライバシーポリシー")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_11
            ], 2)
          ])
        ], 2)
      ])
    ], 2)
  ]))
}
}

})